import { render, staticRenderFns } from "./collectionpic.vue?vue&type=template&id=588a836a&"
import script from "./collectionpic.vue?vue&type=script&lang=js&"
export * from "./collectionpic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports